import { IWidgetResponse } from "../../../api/Base/Base.types";
import { IModeOfTransportationBreakdownByMonth } from "../../../api/ModeOfTransportationBreakdownByMonth/ModeOfTransportationBreakdownByMonth.types";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import "./styles.scss";

interface Props {
  data?: IWidgetResponse<IModeOfTransportationBreakdownByMonth>;
}

function ModeOfTransportationBreakdownByMonth({ data }: Props) {
  function getData() {
    if (data) {
      return data?.data.map((d) => ({
        date: `${d.month}/${d.year}`,
        "Ocean": d.oceanTotal,
        "Truck": d.truckTotal,
        "Rail": d.railTotal,
        "Air": d.airTotal,
      }));
    }
  }

  return (
    <div className="mode-of-transportation-breakdown-by-month">
      <WidgetNivoBase.Bar
        title={
          <Tooltips
            label={
              <>
                <span><b>Air Transportation: </b>Container Size is AIR or Remarks contain air</span>
                <span><b>Rail Transportation: </b>Container Size is RC or Remarks contain Rail Car</span>
                <span><b>Truck Transportation: </b>Container Size is Truck or Remarks contain Truck</span>
                <span><b>Ocean Transportation: </b>All containers not in Air, Rail or Truck</span>
              </>
            }
            children="Mode Of Transportation Breakdown By Month"
          />
        }
        data={getData()}
        keys={["Ocean", "Truck", "Rail", "Air"]}
        indexBy="date"
        marginBottom={50}
        axisLeftName="# Containers"
        axisBottomName=""
        axisBottomRotation={-45}
        groupMode="grouped"
        colors={{ scheme: "nivo" }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            itemWidth: 50,
            itemHeight: 12,
            itemDirection: "left-to-right",
            itemsSpacing: 8,
            symbolShape: "circle",
            symbolSize: 12,
            toggleSerie: true,
            translateX: 0,
            translateY: 50
          },
        ]}
        formatValue={(v) => NumberUtils.toShortened(v, 2)}
        tooltip={({ value, color }) => (
          <div
            style={{
              padding: 12,
              color,
              background: "#222222",
              borderRadius: 10,
            }}
          >
            <strong>{NumberUtils.numberWithCommas(value)}</strong>
          </div>
        )}
      />
    </div>
  );
}

export default ModeOfTransportationBreakdownByMonth;
